import { FC } from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import DecorativeImage from 'components/DecorativeImage';
import Loader from 'components/Loader';

import ButtonRow from '../components/ButtonRow';
import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import { useCompanyCreditCards } from '../hooks/useCompanyCreditCards';
import cutCardsImg from '../images/cut-cards.svg';
import locales from './locales';

const CutCards: FC = () => {
  const { creditCards, loading } = useCompanyCreditCards();

  const hasMultipleCards = creditCards.length > 1;
  const title = locales.title[hasMultipleCards ? 'plural' : 'singular'];
  const body = locales.body[hasMultipleCards ? 'plural' : 'singular'];

  return (
    <Wrapper>
      {loading ? (
        <Loader />
      ) : (
        <>
          <DecorativeImage src={cutCardsImg} />
          <Title>{title}</Title>
          <Text size="sm">{body}</Text>
          <ButtonRow>
            <Button
              as={Link}
              icon="arrow-right"
              iconPosition="right"
              to="/company/account-closure/confirm"
            >
              {locales.next}
            </Button>
          </ButtonRow>
        </>
      )}
    </Wrapper>
  );
};

export default CutCards;
